module.exports = __webpack_public_path__ + "img/advisory_select_type.6afdc131.png";